// extracted by mini-css-extract-plugin
export default {"forbidden":"Forbidden_forbidden__99LGA","content":"Forbidden_content__YB2Vy"};